import { useQuery } from '@tanstack/react-query'
import { api } from './api'

export interface Summary {
  cluster: { nodes: number; services: number; stacks: number }
  alerts: { open: number; critical: number }
  backups: { ok_24h: number; failed_24h: number }
  findings: { active: number }
  recent_alerts: { id: string; severity: string; title: string; opened_at: string; closed_at: string | null }[]
  recent_backups: {
    id: string
    status: string
    kind: string
    service_name: string | null
    stack: string | null
    started_at: string | null
    finished_at: string | null
    size_bytes: number | null
    duration_s: number | null
    error_preview: string | null
  }[]
}

export function useSummary() {
  return useQuery<Summary>({
    queryKey: ['summary'],
    queryFn: () => api<Summary>('/api/summary'),
    refetchInterval: 15_000,
  })
}
